import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, PresignedUrl } from '../../types/global';
import { DropBoxPresignedUrlDownloadResponse } from '../../api-models';
import BaseAdapter from './baseAdapter';

export default class PostDropBoxDownload extends BaseAdapter<DropBoxPresignedUrlDownloadResponse> implements AdapterInterface {
  rawResponse: DropBoxPresignedUrlDownloadResponse;

  async adaptResponse(request: { s3Key: string }): Promise<PresignedUrl> {
    await this.fetchApiResponse('/api/drop-box/download', HTTPMethod.Post, {
      s3_key: request.s3Key,
    });
    return {
      presignedUrl: this.rawResponse.presigned_url,
    };
  }
}
